import React from "react";
import LicenseUploadSection from "./LicenseUploadSection";
import { getParams } from "../view/urlService";
import { Key, Calendar, HardDrive } from "lucide-react";

export function ActiveLicenseInfo({ license, machineData }) {

    const onCopyClick = async (value) => await navigator.clipboard.writeText(value);

    //const errorMessage = getParams().message;
    const errorMessage = getParams().strlic;

    return (
        <div className="oct_license-card-v2 w-100 mb-0">
            {/* License Header */}
            <div className="oct_license-header-v2">
                <h3>
                    <Key className="oct_icon" />
                    {errorMessage || 'License Info'}
                </h3>
                <div className="oct_license-meta">
                    <div className="oct_uuid cursor-pointer" onClick={() => onCopyClick(machineData.UUID)} title="Click to copy">
                        UUID: {machineData.UUID || 'Failed to load UUID'}
                    </div>
                    {machineData.vmFact && (
                        <div className="oct_vm cursor-pointer" onClick={() => onCopyClick(machineData.vmFact)} title="Click to copy">
                            Virtual Machine: {machineData.vmFact}
                        </div>
                    )}
                </div>
            </div>

            {/* License Details Grid */}
            <div className="oct_license-grid-v2">
                {/* End Date */}
                <div className="oct_license-stat-card-v2">
                    <div className="oct_icon-wrapper oct_calendar-bg">
                        <Calendar className="oct_icon" />
                    </div>
                    <div className="oct_stat-content">
                        <p className="oct_stat-label">End Date</p>
                        <p className="oct_stat-value">{license.endDate}</p>
                    </div>
                </div>

                {/* Max Devices */}
                <div className="oct_license-stat-card-v2">
                    <div className="oct_icon-wrapper oct_devices-bg">
                        <HardDrive className="oct_icon" />
                    </div>
                    <div className="oct_stat-content">
                        <p className="oct_stat-label">Max Devices</p>
                        <p className="oct_stat-value">{license.maxDevices}</p>
                    </div>
                </div>
            </div>

            {/* License Key Section / Upload Section */}
            <LicenseUploadSection />
        </div>
    )

}